<template>
  <!-- Компонент вопрос -->
  <QuizQuestion :question="question" />
  <!-- Компонент вопрос -->

  <div class="quiz-options quiz__lines" ref="quizLines">
    <div
      v-for="(pair, index) in question.pairs"
      :key="index"
      class="quiz__lines-row"
    >
      <div class="quiz__lines-column quiz__lines-column--left">
        <div
          class="quiz__option"
          :data-lines-option-left="index"
        >
          <span>{{ pair[0] }}</span>
        </div>
      </div>

      <div class="quiz__lines-line"></div>

      <div class="quiz__lines-remove">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path d="M6.99951 1.00024L0.999965 6.99979" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <path d="M6.99951 6.99976L0.999967 1.00021" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>

      <div class="quiz__lines-column quiz__lines-column--right">
        <div
          class="quiz__option"
          :class="{ 'disabled': isRightOptionConnected(shuffledRightItems[index]?.originalIndex) }"
          :data-lines-option-right="shuffledRightItems[index]?.originalIndex"
        >
          <span>{{ shuffledRightItems[index]?.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuizQuestion from "@/components/QuizQuestion/QuizQuestion.vue";

export default {
  name: 'MatchingQuestion',
  components: {
    QuizQuestion
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedAnswers: {
      type: Object,
      default: () => ({})
    },
    showResults: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answers-updated'],
  data() {
    return {
      shuffledRightItems: [],
      connections: []
    };
  },
  watch: {
    question: {
      immediate: true,
      handler(newQuestion) {
        if (newQuestion && newQuestion.pairs) {
          this.generateShuffledRightItems(newQuestion);
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeMatchingLogic();
    });
  },
  methods: {
    initializeMatchingLogic() {
      const quizLines = document.querySelector(".quiz-options.quiz__lines");
      if (quizLines) {
        let selectedLeftOption = null;
        let connections = [];
        const nextButton = document.querySelector(".quiz-button .btn");

        // Добавляем контейнер для SVG линий
        const svgContainer = document.createElement("div");
        svgContainer.classList.add("svg-container");
        svgContainer.style.position = "absolute";
        svgContainer.style.top = "0";
        svgContainer.style.left = "0";
        svgContainer.style.width = "100%";
        svgContainer.style.height = "100%";
        svgContainer.style.pointerEvents = "none";
        svgContainer.style.zIndex = "10";
        quizLines.style.position = "relative";
        quizLines.appendChild(svgContainer);

        // Функция для активации кнопки удаления (крестика)
        const activateRemoveButton = (leftIndex) => {
          const leftOption = document.querySelector(`[data-lines-option-left="${leftIndex}"]`);
          if (!leftOption) return;

          const row = leftOption.closest(".quiz__lines-row");
          if (!row) return;

          const removeBtn = row.querySelector(".quiz__lines-remove");
          if (removeBtn) {
            removeBtn.classList.add("active");

            // Добавляем обработчик события на удаление соединения, если его еще нет
            if (!removeBtn.hasAttribute("data-has-listener")) {
              removeBtn.addEventListener("click", () => {
                removeConnection(leftIndex);
              });
              removeBtn.setAttribute("data-has-listener", "true");
            }
          }
        };

        // Функция для удаления соединения
        const removeConnection = (leftIndex) => {
          // Находим соединение в массиве
          const connectionIndex = connections.findIndex(conn => conn.leftIndex === leftIndex);

          if (connectionIndex !== -1) {
            const connection = connections[connectionIndex];

            // Удаляем SVG соединение
            const svg = document.getElementById(`connection-${leftIndex}`);
            if (svg) svg.remove();

            // Находим связанные элементы
            const leftOption = document.querySelector(`[data-lines-option-left="${leftIndex}"]`);
            const rightOption = document.querySelector(`[data-lines-option-right="${connection.rightIndex}"]`);

            // Удаляем класс active с колонок
            if (leftOption && leftOption.parentElement) {
              leftOption.parentElement.classList.remove("active");
              // Убираем класс connected, чтобы можно было снова кликать на элемент
              leftOption.classList.remove("connected");
            }

            if (rightOption && rightOption.parentElement) {
              rightOption.parentElement.classList.remove("active");
            }

            // Находим строку и линию
            const lineRow = leftOption ? leftOption.closest(".quiz__lines-row") : null;
            const line = lineRow ? lineRow.querySelector(".quiz__lines-line") : null;
            const removeBtn = lineRow ? lineRow.querySelector(".quiz__lines-remove") : null;

            // Отображаем стандартную линию и удаляем data-connectedTo
            if (line) {
              line.style.display = "";
              delete line.dataset.connectedTo;
            }

            // Деактивируем кнопку удаления
            if (removeBtn) {
              removeBtn.classList.remove("active");
            }

            // Удаляем соединение из массива
            connections.splice(connectionIndex, 1);

            // Эмитим обновление ответов
            this.emitAnswersUpdate(connections);

            // Если соединений меньше чем общее количество опций слева, то деактивируем кнопку Далее
            if (connections.length < document.querySelectorAll(".quiz__lines-column--left .quiz__option").length) {
              if (nextButton) {
                nextButton.setAttribute("disabled", "disabled");
              }
            }
          }
        };

        // Обработка клика по элементу левой колонки
        const leftOptions = quizLines.querySelectorAll(".quiz__lines-column--left .quiz__option");
        leftOptions.forEach((option) => {
          option.addEventListener("click", () => {
            const leftIndex = option.getAttribute("data-lines-option-left");
            
            // Проверяем, не соединен ли уже этот элемент
            const isConnected = connections.some(conn => conn.leftIndex === leftIndex);
            if (isConnected) {
              return; // Если элемент уже соединен, не позволяем кликать на него
            }

            // Если уже есть выбранный элемент слева, снимаем выделение
            if (selectedLeftOption) {
              selectedLeftOption.parentElement.classList.remove("active");
            }

            // Выбираем текущий элемент
            selectedLeftOption = option;
            option.parentElement.classList.add("active");

            // Добавляем класс is-choosing для показа, что происходит выбор
            quizLines.classList.add("is-choosing");
          });
        });

        // Обработка клика по элементу правой колонки
        const rightOptions = quizLines.querySelectorAll(".quiz__lines-column--right .quiz__option");
        rightOptions.forEach((option) => {
          option.addEventListener("click", () => {
            // Проверяем, что опция не заблокирована
            if (option.classList.contains("disabled")) {
              return;
            }

            // Проверяем, что есть выбранный элемент слева
            if (selectedLeftOption && quizLines.classList.contains("is-choosing")) {
              const leftIndex = selectedLeftOption.getAttribute("data-lines-option-left");
              const rightIndex = option.getAttribute("data-lines-option-right");

              // Находим соответствующую строку и линию
              const lineRow = selectedLeftOption.closest(".quiz__lines-row");
              const line = lineRow.querySelector(".quiz__lines-line");

              // Проверяем, не использована ли уже эта опция слева
              const existingConnection = connections.find(conn => conn.leftIndex === leftIndex);

              // Если существует предыдущее соединение, обновляем его
              if (existingConnection) {
                // Удаляем существующий SVG, если он есть
                const existingSvg = document.getElementById(`connection-${leftIndex}`);
                if (existingSvg) {
                  existingSvg.remove();
                }

                // Обновляем соединение
                existingConnection.rightIndex = rightIndex;
              } else {
                // Создаем новое соединение
                connections.push({leftIndex, rightIndex});
              }

              // Создаем соединение
              createSvgConnection(leftIndex, rightIndex);

              // Скрываем стандартную линию только для текущей строки
              line.style.display = "none";

              // Сохраняем соответствие линии и правого элемента
              line.dataset.connectedTo = rightIndex;

              // Добавляем класс active к обеим колонкам для отображения выбранных ячеек
              selectedLeftOption.parentElement.classList.add("active");
              option.parentElement.classList.add("active");

              // Добавляем класс connected к левому элементу, чтобы заблокировать повторные клики
              selectedLeftOption.classList.add("connected");

              // Активируем кнопку удаления (крестик)
              activateRemoveButton(leftIndex);

              // Сбрасываем выбор для текущего взаимодействия
              selectedLeftOption = null;
              quizLines.classList.remove("is-choosing");

              // Эмитим обновление ответов
              this.emitAnswersUpdate(connections);

              // Если все соединения созданы, активируем кнопку Далее
              if (connections.length === leftOptions.length) {
                if (nextButton) {
                  nextButton.removeAttribute("disabled");
                }
              }
            }
          });
        });

        // Функция для создания SVG-соединения
        const createSvgConnection = (leftIndex, rightIndex) => {
          const leftOption = document.querySelector(`[data-lines-option-left="${leftIndex}"]`);
          const rightOption = document.querySelector(`[data-lines-option-right="${rightIndex}"]`);

          if (!leftOption || !rightOption) return;

          // Получаем координаты элементов относительно контейнера quizLines
          const containerRect = quizLines.getBoundingClientRect();
          const leftRect = leftOption.getBoundingClientRect();
          const rightRect = rightOption.getBoundingClientRect();

          // Рассчитываем координаты точек относительно контейнера SVG
          const startX = leftRect.right - containerRect.left;
          const startY = leftRect.top + leftRect.height / 2 - containerRect.top;
          const endX = rightRect.left - containerRect.left;
          const endY = rightRect.top + rightRect.height / 2 - containerRect.top;

          // Создаем SVG элемент
          const svgNS = "http://www.w3.org/2000/svg";
          const svg = document.createElementNS(svgNS, "svg");
          svg.setAttribute("id", `connection-${leftIndex}`);
          svg.setAttribute("width", "100%");
          svg.setAttribute("height", "100%");
          svg.style.position = "absolute";
          svg.style.top = "0";
          svg.style.left = "0";
          svg.style.width = "100%";
          svg.style.height = "100%";
          svg.style.pointerEvents = "none";

          // Создаем path для изогнутой линии
          const path = document.createElementNS(svgNS, "path");

          // Определяем находятся ли элементы в одной строке ВИЗУАЛЬНО
          // Проверяем по координатам Y - если разница меньше 10px, считаем что в одной строке
          const sameRow = Math.abs(startY - endY) < 10;

          if (sameRow) {
            // Если элементы в одной строке визуально - рисуем прямую линию
            const d = `M${startX},${startY} L${endX},${endY}`;
            path.setAttribute("d", d);
          } else {
            // Устанавливаем радиус скругления
            const radius = 15;

            // Вычисляем общее горизонтальное расстояние с учетом скруглений
            const totalWidth = endX - startX;

            // Определяем смещение вертикальной линии в зависимости от номера строки
            let offset = 0;

            // Применяем разное смещение для разных линий (по индексу leftIndex)
            switch (leftIndex) {
              case "0": // Первая линия - равные отрезки
                offset = 0;
                break;
              case "1": // Вторая линия - отрезок до изгиба короче на 5px
                offset = -5;
                break;
              case "2": // Третья линия - отрезок до изгиба короче на 7px
                offset = -7;
                break;
              case "3": // Четвертая линия - отрезок до изгиба короче на 10px
                offset = -10;
                break;
              default:
                offset = 0;
            }

            // Вычисляем фактическую длину горизонтальных отрезков с учетом смещения
            const halfWidth = totalWidth / 2;

            // Добавляем смещение к центральной точке
            const midpointX = startX + halfWidth + offset;

            // Создаем путь со скругленными углами
            // Теперь с учетом смещения для каждой линии
            const isGoingDown = endY > startY;

            let d;
            if (isGoingDown) {
              // Если линия идет вниз
              d = `M${startX},${startY}
                   L${midpointX - radius},${startY}
                   Q${midpointX},${startY} ${midpointX},${startY + radius}
                   L${midpointX},${endY - radius}
                   Q${midpointX},${endY} ${midpointX + radius},${endY}
                   L${endX},${endY}`;
            } else {
              // Если линия идет вверх
              d = `M${startX},${startY}
                   L${midpointX - radius},${startY}
                   Q${midpointX},${startY} ${midpointX},${startY - radius}
                   L${midpointX},${endY + radius}
                   Q${midpointX},${endY} ${midpointX + radius},${endY}
                   L${endX},${endY}`;
            }

            path.setAttribute("d", d);
          }

          path.setAttribute("stroke", "#EC001A");
          path.setAttribute("stroke-width", "2");
          path.setAttribute("fill", "none");

          // Добавляем круг в начале
          const startCircle = document.createElementNS(svgNS, "circle");
          startCircle.setAttribute("cx", startX);
          startCircle.setAttribute("cy", startY);
          startCircle.setAttribute("r", "5");
          startCircle.setAttribute("fill", "#EC001A");

          // Добавляем стрелку в конце
          const arrowSize = 6;

          // Создаем линии стрелки
          const arrowLine1 = document.createElementNS(svgNS, "line");
          arrowLine1.setAttribute("x1", endX - arrowSize);
          arrowLine1.setAttribute("y1", endY - arrowSize);
          arrowLine1.setAttribute("x2", endX);
          arrowLine1.setAttribute("y2", endY);
          arrowLine1.setAttribute("stroke", "#EC001A");
          arrowLine1.setAttribute("stroke-width", "2");

          const arrowLine2 = document.createElementNS(svgNS, "line");
          arrowLine2.setAttribute("x1", endX - arrowSize);
          arrowLine2.setAttribute("y1", endY + arrowSize);
          arrowLine2.setAttribute("x2", endX);
          arrowLine2.setAttribute("y2", endY);
          arrowLine2.setAttribute("stroke", "#EC001A");
          arrowLine2.setAttribute("stroke-width", "2");

          // Добавляем элементы в SVG
          svg.appendChild(path);
          svg.appendChild(startCircle);
          svg.appendChild(arrowLine1);
          svg.appendChild(arrowLine2);

          // Добавляем SVG в контейнер
          svgContainer.appendChild(svg);
        };

        // Обработка и восстановление предыдущих соединений, если они есть
        // Проверяем, существуют ли предустановленные соединения в разметке
        const linePre = document.querySelectorAll(".quiz__lines-line.active");
        if (linePre.length > 0) {
          // Если есть активные линии, строим по ним соединения
          linePre.forEach(line => {
            const lineRow = line.closest(".quiz__lines-row");
            if (lineRow) {
              const leftOption = lineRow.querySelector(".quiz__lines-column--left .quiz__option");
              if (leftOption) {
                const leftIndex = leftOption.getAttribute("data-lines-option-left");
                const rightIndex = line.dataset.connectedTo;

                if (leftIndex !== null && rightIndex !== undefined) {
                  // Добавляем соединение в массив
                  connections.push({leftIndex, rightIndex});

                  // Создаем SVG-соединение
                  createSvgConnection(leftIndex, rightIndex);

                  // Скрываем стандартную линию
                  line.style.display = "none";

                  // Добавляем класс active к колонкам для уже существующих соединений
                  const leftColumn = leftOption.parentElement;
                  if (leftColumn) leftColumn.classList.add("active");

                  // Добавляем класс connected к левому элементу
                  leftOption.classList.add("connected");

                  // Активируем кнопку удаления (крестик)
                  activateRemoveButton(leftIndex);

                  // Находим соответствующий правый элемент и добавляем класс active
                  const rightOption = document.querySelector(`[data-lines-option-right="${rightIndex}"]`);
                  if (rightOption) {
                    const rightColumn = rightOption.parentElement;
                    if (rightColumn) rightColumn.classList.add("active");
                  }
                }
              }
            }
          });
        }

        // Проверка на уже существующие атрибуты data-chosen в разметке
        document.querySelectorAll(".quiz__lines-row").forEach(row => {
          const leftOption = row.querySelector(".quiz__lines-column--left .quiz__option");
          const line = row.querySelector(".quiz__lines-line");

          if (leftOption && line && line.dataset.connectedTo) {
            const leftIndex = leftOption.getAttribute("data-lines-option-left");
            const rightIndex = line.dataset.connectedTo;

            // Проверяем, нет ли уже такого соединения
            const exists = connections.some(conn => conn.leftIndex === leftIndex);
            if (!exists && leftIndex !== null && rightIndex !== undefined) {
              // Добавляем соединение в массив
              connections.push({leftIndex, rightIndex});

              // Создаем SVG-соединение
              createSvgConnection(leftIndex, rightIndex);

              // Скрываем стандартную линию
              line.style.display = "none";

              // Добавляем класс active к колонкам
              if (leftOption) {
                const leftColumn = leftOption.parentElement;
                if (leftColumn) leftColumn.classList.add("active");

                // Добавляем класс connected к левому элементу
                leftOption.classList.add("connected");

                // Активируем кнопку удаления (крестик)
                activateRemoveButton(leftIndex);
              }

              // Находим и добавляем класс active к правой колонке
              const rightOption = document.querySelector(`[data-lines-option-right="${rightIndex}"]`);
              if (rightOption) {
                const rightColumn = rightOption.parentElement;
                if (rightColumn) rightColumn.classList.add("active");
              }
            }
          }
        });

        // Обновляем локальный массив connections после восстановления
        this.connections = connections;
      }
    },
    emitAnswersUpdate(connections) {
      const answers = {};
      connections.forEach(conn => {
        answers[conn.leftIndex] = parseInt(conn.rightIndex);
      });
      
      // Сохраняем соединения в data для отслеживания заблокированных опций
      this.connections = connections;
      
      this.$emit('answers-updated', this.question.id, answers);
    },
    generateShuffledRightItems(question) {
      // Создаем массив правых элементов с оригинальными индексами
      const rightItems = question.pairs.map((pair, index) => ({
        originalIndex: index,
        text: pair[1]
      }));
      // Явно задаём порядок: 100, 75, 25, 50
      const fixedOrder = [3, 0, 2, 1];
      this.shuffledRightItems = fixedOrder.map(i => rightItems[i]);
    },
    isRightOptionConnected(rightIndex) {
      return this.connections.some(conn => conn.rightIndex === rightIndex.toString());
    }
  }
};
</script>

<style scoped lang="scss">
.quiz-options.quiz__lines {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &.is-choosing {
    .quiz__lines-column {
      &--right .quiz__option {
        border-color: var(--red);
      }
    }
  }

  .quiz__lines-row {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .quiz__lines-column {
    .quiz__option {
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    &--left {
      width: 102px;

      .quiz__option {
        @include text-16-700;

        padding: 20px 16px;
        background-color: var(--white);
        border-radius: 80px;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      &.active {
        .quiz__option {
          color: var(--white);
          background-color: var(--red);
          border-color: var(--red);
        }
      }
    }

    &--right {
      max-width: 140px;

      .quiz__option {
        @include text-14-700;

        padding: 14px 10px;
        background-color: transparent;
        border-radius: 28px;
        border: 2px dashed var(--gray);
      }

      &.active {
        .quiz__option {
          color: var(--red);
          border: 2px solid var(--red);
        }
      }
    }
  }

  .quiz__lines-line {
    position: absolute;
    top: 50%;
    left: 100px;
    display: flex;
    width: 24px;
    height: 2px;
    background-color: var(--red);
    transform: translateY(-50%);

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 2px;
      width: 10px;
      height: 10px;
      background-color: var(--red);
      border-radius: 100%;
      transform: translateX(-50%) translateY(-50%);
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      width: 10px;
      height: 10px;
      border-top: 2px solid var(--red);
      border-right: 2px solid var(--red);
      transform: rotate(45deg) translate(-25%, -45%);
    }
  }

  .quiz__lines-remove {
    position: absolute;
    top: 50%;
    left: 130px;
    display: none;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
    background: var(--red);
    border-radius: 100%;
    transform: translate(0, -50%);
    z-index: 12;

    &.active {
      display: flex;
    }
  }
}

</style>
